import createReactClass from 'create-react-class';
import React from 'react';
import { SchematicAPI } from '../actions/schematicAPI';
import Constants from '../constants/constants';
import { restrictionRequestStore } from '../stores/restrictionRequest';
import { schematicToolbarStore } from '../stores/schematicToolbar';
import { tabsStore } from '../stores/tabs';
import { userStore } from '../stores/user';

function getStateFromStores() {
    return {
        navigating: schematicToolbarStore.isNavigating(),
        excluding: schematicToolbarStore.isExcluding(),
        isVisible: schematicToolbarStore.isVisible(),
        exclusionList: schematicToolbarStore.getExclusionList(),
        restriction: restrictionRequestStore.getForm(),
        isReadOnly: restrictionRequestStore.getReadOnly(),
        isPartialReadOnly: restrictionRequestStore.getPartialReadOnly(),
        tabIndex: tabsStore.getTabIndex()
    }
}

export const SchematicToolBar = createReactClass({
    componentDidMount: function () {
        schematicToolbarStore.subscribe(this._onChange);
        restrictionRequestStore.subscribe(this._onChange);
        userStore.subscribe(this._onChange);
        tabsStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        schematicToolbarStore.unsubscribe(this._onChange);
        restrictionRequestStore.unsubscribe(this._onChange);
        userStore.unsubscribe(this._onChange);
        tabsStore.unsubscribe(this._onChange);
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    navOnClick: function () {
        SchematicAPI.setNavigate();
    },

    excludeOnClick: function () {
        SchematicAPI.setExclude();
    },

    centerAndZoom: function () {
        SchematicAPI.centerAndZoom();
    },

    render: function () {
        var navClass = "buttonContainer ";
        var exclClass = "buttonContainer ";
        if (this.state.navigating) {
            navClass += "selectedToolbarButton";
        }
        else if (this.state.excluding) {
            exclClass += "selectedToolbarButton";
        }

        var content = (<div></div>);

        if (this.state.isVisible && !this.state.isReadOnly && !(this.state.isPartialReadOnly && userStore.getSelectedRole().indexOf(Constants.Roles.FIELD_USER) > -1)) {
            content = (
                <div>
                    <div style={{ overflow: 'hidden', width: '96px' }}>
                        <div className={navClass} style={{ float: 'left' }} onClick={this.navOnClick}
                            title="Navigation Mode">
                            <span className="glyphicon glyphicon-move"></span>{/*navigate*/}
                        </div>
                        <div className={exclClass} style={{ float: 'left' }} onClick={this.excludeOnClick}
                            title="Exclusion Mode: Ctrl">
                            <span className="glyphicon glyphicon-hand-up"></span>{/*deselect*/}
                        </div>
                        <div className="buttonContainer" style={{ float: 'left' }} onClick={this.centerAndZoom}
                            title="Center and Zoom Schematic on Selection">
                            <span className="glyphicon glyphicon-record"></span>{/*center and zoom*/}
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }
});
